import { createFileRoute, Link } from "@tanstack/react-router";
import { PortalShell, StatusBadge } from "@/components/business/B2BPortal";
import { SEOHead } from "@/components/shared/SEOHead";
import {
  productByIdFromSnapshot,
  useBusinessPortalSnapshot,
} from "@/lib/b2bPortalApi";

export const Route = createFileRoute("/business/portal/orders")({
  component: OrdersPage,
});

function OrdersPage() {
  const portal = useBusinessPortalSnapshot();
  const { account, orders, projects } = portal.data;

  return (
    <PortalShell
      active="/business/portal/orders"
      eyebrow="Orders"
      title="Orders and reorders"
      description="Track current orders and repeat past work."
      account={account}
      actions={(
        <>
          <button type="button" className="b2b-secondary-button" onClick={() => void portal.refresh()}>
            Refresh
          </button>
          <Link to="/business/portal/projects/new" className="b2b-primary-button">
            New order
          </Link>
        </>
      )}
    >
      <SEOHead title="Packaging Orders" description="Track your Quuil business packaging orders." path="/business/portal/orders" robots="noindex,follow" />

      {portal.loading ? (
        <section className="b2b-table-card b2b-loading-card">
          <div />
          <div />
          <div />
        </section>
      ) : orders.length > 0 ? (
        <section className="b2b-table-card">
          <table>
            <thead>
              <tr>
                <th>Order</th>
                <th>Project</th>
                <th>Packaging</th>
                <th>Status</th>
                <th>Expected ship</th>
                <th>Details</th>
                <th>Reorder</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                const project = projects.find((item) => item.id === order.projectId);
                const product = productByIdFromSnapshot(portal.data, project?.productId ?? "");
                return (
                  <tr key={order.id}>
                    <td><Link to="/business/portal/orders/$orderId" params={{ orderId: order.id }}>{order.id}</Link></td>
                    <td>{project?.name ?? "Packaging order"}</td>
                    <td>{product?.title ?? "Packaging"}</td>
                    <td><StatusBadge status={order.status} tone={order.status === "delivered" ? "good" : "warn"} /></td>
                    <td>{order.expectedShipDate || "Pending"}</td>
                    <td>
                      <Link to="/business/portal/orders/$orderId" params={{ orderId: order.id }} className="b2b-table-action">
                        Open
                      </Link>
                    </td>
                    <td>
                      <Link to="/business/portal/projects/new" className="b2b-table-action">
                        Reorder
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      ) : (
        <section className="b2b-card b2b-empty-state">
          <h2>No orders yet</h2>
          <p>Orders will appear here after a quote is approved.</p>
          <Link to="/business/portal/projects/new" className="b2b-primary-button">
            Start order
          </Link>
        </section>
      )}
    </PortalShell>
  );
}
